export default __webpack_public_path__ + "static/Entenda0088-b40a17951a7a5ed148d1e42b1b699c41.jpg";